var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoothCl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.9 22",
    style: {
      enableBackground: "new 0 0 24.9 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FC4D50;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1436 -33)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1460.4,33h-3.2c-0.2,0-0.4,0.2-0.5,0.4l-0.4,2.6c0,0.2-0.2,0.4-0.5,0.4h-19.4c-0.3,0-0.5,0.2-0.5,0.5 c0,0,0,0.1,0,0.1l1.9,11.5c0,0.2,0.2,0.4,0.5,0.4h17.4c0.2,0,0.4-0.2,0.5-0.4l2.2-13.2c0-0.2,0.2-0.4,0.5-0.4h1.5 c0.3,0,0.5-0.2,0.5-0.5v-1C1460.9,33.2,1460.6,33,1460.4,33C1460.4,33,1460.4,33,1460.4,33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1441,50.6c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2C1443.2,51.6,1442.2,50.6,1441,50.6 L1441,50.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1453.5,50.6c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2C1455.7,51.6,1454.7,50.6,1453.5,50.6 L1453.5,50.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoothCl);
export default __webpack_public_path__ + "static/media/booth_cl.c6d2981eaa250153958be659ad724a29.svg";
export { ForwardRef as ReactComponent };